document.addEventListener('DOMContentLoaded', function () {
    (function (window, document) {

    // Close : Remove video instance
    document.querySelectorAll('.modal-video').forEach(function (modal) {
        modal.addEventListener('hidden.bs.modal', function (event) {

            let iframe = modal.querySelector('.player');
            if (iframe) {
                let iframeSrc = iframe.src;
                iframe.src = '';
                // but reactive src after timer
                setTimeout(function () {
                    iframe.src = iframeSrc;
                }, 1000);

            }
        });
    });

    })(window, document);
});
